<template>
  <div class="product-details">
    <h1>{{ title[language] }}</h1>
    <p>{{ description[language] }}</p>
  </div>
</template>

<script>
import Button from "@/components/UI/Button.vue";
export default {
  name: "ProductDetails",
  components: { Button },
  props: {
    title: {
      type: Object,
      required: true,
    },
    description: {
      type: Object,
      default: "",
    },
    language: {
      type: String,
      default: "en",
    },
  },
};
</script>

<style>
.product-details p {
  margin-bottom: 2rem;
  color: var(--rofix-gray);
}
</style>
